<div class="result-score-bar" [pTooltip]="tooltipText()" [tooltipOptions]="tooltipOptions">
  <div class="result-score-bar__track bg-gray-700">
    <div
      class="result-score-bar__segment result-score-bar__segment--rfi"
      [style.width.%]="rfiWidth()"
      [style.backgroundColor]="rfiColor"
    ></div>
    <div
      class="result-score-bar__segment result-score-bar__segment--rfp"
      [style.width.%]="rfpWidth()"
      [style.backgroundColor]="rfpColor"
    ></div>
    <div
      class="result-score-bar__segment result-score-bar__segment--rfd"
      [style.width.%]="rfdWidth()"
      [style.backgroundColor]="rfdColor"
    ></div>
    <div class="bg-gray-700" [style.width.%]="remainderWidth()"></div>
  </div>
</div>
